import {
  qidaApi,
  kngApi
} from 'yxt-biz-pc/packages/api';

// 获取机构参
export const getOrgpParameter = (code, orgId) => {
  return qidaApi.get(`orgparsetting/code?code=${code}&orgId=${orgId}`);
};

// 获取指定对象下的标签列表
export const getScormChapters = (kngId) => {
  return kngApi.get(`/scorm/chapter/${kngId}`);
};
